<template>
  <div>
    <v-toolbar elevation="0">
      <v-toolbar-title class="primary--text">
        <h2>Disposals</h2>
      </v-toolbar-title>
    </v-toolbar>
    <div v-if="loading">
      <v-row align="center" justify="center">
        <v-col>
          <Loading></Loading>
        </v-col>
      </v-row>
    </div>
    <div v-if="!loading">
      <v-container>
        <DriverTabs v-bind:bookings="disposals" />
      </v-container>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading';
import DriverTabs from '@/components/drivers/dashboard/DriverTabs';

export default {
  name: 'DriverDisposals',
  components: {
    Loading,
    DriverTabs
  },
  data() {
    return {
      show: true,
      title: '',
      subTitle: '',
      tab: ''
    }
  },
  computed: {
    loading() {
      return this.$store.getters.getLoading;
    },
    bookingError() {
      return this.$store.getters.getBookingError;
    },
    user() {
      return this.$store.getters['auth/getUser'];
    },
    disposals(){
        return this.$store.getters.getDisposingBookings;
    }
  },
  watch: {
    bookingError(error) {
      if (error) {
        console.log(error.message);
      }
    }
  },
  mounted() {
    if(this.$store.state.booking.driverBookings.length === 0){
      this.$store.dispatch('fetchDriverBookings', this.user.id); 
    }
  }
}
</script>

<style lang="scss" scoped>

</style>